export default __webpack_public_path__ + "static/media/banner13.07490906.png";